import React, { useState } from 'react' // Import React
import styled, { css } from 'styled-components'

import Icon from '../../../../../common/components/icons/index'

interface IProps {
  parentCallback: (message: string) => void
}
export default function Footer(props: IProps) {
  const [message, setMessage] = useState('')

  const onsubmit = (e) => {
    e.preventDefault()
    if (message === '') return
    props.parentCallback(message)
    setMessage('')
  }

  return (
    <Wrapper onSubmit={onsubmit}>
      <Input
        style={{ border: 'none', outline: 'none', background: 'white' }}
        placeholder="Type a message here .."
        onChange={(value) => {
          setMessage(value.target.value)
        }}
        value={message}
      />
      <SendMessageButton onClick={onsubmit} style={{ border: 'none' }}>
        <Icon id="send" className="icon" />
      </SendMessageButton>
    </Wrapper>
  )
}

const Wrapper = styled.form`
  padding: 10px;
  height: 60px;
  position: relative;
  display: flex;
  align-items: center;
`

const iconCommonStyles = css`
  color: '#00000099';
`

const Input = styled.input`
  background: 'white';
  color: '#00000099';

  padding: 20px 10px;
  border-radius: 10px;
  flex: 1;
  height: 100%;
  margin-left: 7px;

  &::placeholder {
    color: '#00000099';
    font-size: 0.9rem;
  }

  &:focus {
    outline: none;
  }
`

const SendMessageButton = styled.button`
  .icon {
    margin-left: 8px;
    margin-right: 8px;
    width: 28px;
    height: 28px;
    padding: 3px;
    border-radius: 50%;
    ${iconCommonStyles}
  }
`
